"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Stop editing on blur.
 */
exports.default = function (event, _ref) {
    var getProps = _ref.getProps;

    var _getProps = getProps(),
        stopEditing = _getProps.stopEditing;

    if (!stopEditing) return;

    stopEditing();
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/stopEditingOnBlur/onBlur.js
// module id = 1744
// module chunks = 0